/**
 * 消息类型常量
 */
export const MessageTypeConstants = {
  /**
   * 桌台预订
   */
  MESSAGE_TYPE_TABLE_RESERVATION: 1,
  /**
   * 库存预警
   */
  MESSAGE_TYPE_STOCK_WARNING: 2,
  /**
   * 预订过期
   * 消息内容为json string(com.zodance.teashopbe.merchant.api.entity.MerchantOmsTableReservation)
   */
  MESSAGE_TYPE_RESERVATION_EXPIRED: 3,
  /**
   * 服务呼叫
   */
  MESSAGE_TYPE_CALL_SERVICE: 4,
  /**
   * 用户点单
   */
  MESSAGE_TYPE_USER_ORDER: 5,
  /**
   * 已自动预结账
   * 消息内容为json string(com.zodance.teashopbe.merchant.api.entity.MerchantTable)
   */
  MESSAGE_TYPE_PRE_CHECK_COMPLETE: 6,
  /**
   * 暂停完成
   * 消息内容为json string(com.zodance.teashopbe.merchant.api.entity.MerchantTable)
   */
  MESSAGE_TYPE_PAUSE_COMPLETE: 7,
  /**
   * 预结账时间剩余15分钟
   * 消息内容为json string(com.zodance.teashopbe.merchant.api.entity.MerchantTable)
   */
  MESSAGE_TYPE_PRE_CHECK_REMINDER: 8,
  /**
   * 积分兑换通知
   */
  MESSAGE_TYPE_CREDIT_EXCHANGE_NOTIFICATION: 9,
  /**
   * 包段倒计时提醒
   */
  MESSAGE_TYPE_PACKAGE_COUNTDOWN_REMINDER: 10,
  /**
   * 小茶助手主动消息
   */
  MESSAGE_TYPE_XIAOCHA_ASSISTANT: 11,
} as const

export type MessageType = typeof MessageTypeConstants[keyof typeof MessageTypeConstants]

/**
 * 消息状态常量
 */
export const MessageStatusConstants = {
  /**
   * 未处理
   */
  NOT_PROCESSED: 1,
  /**
   * 已处理
   */
  PROCESSED: 2,
  /**
   * 已删除
   */
  DELETED: 3,
} as const

export type MessageStatus = typeof MessageStatusConstants[keyof typeof MessageStatusConstants]

/**
 * 店铺消息通知记录表
 */
export interface MerchantMessageRecord {
  /**
   * 编号
   */
  merchantMessageRecordId?: number

  /**
   * 消息类型
   * @see com.zodance.teashopbe.merchant.api.constants.MessageTypeConstants
   */
  messageType: MessageType

  /**
   * 关联店铺id
   */
  shopId: number

  /**
   * 消息状态
   * @see com.zodance.teashopbe.merchant.api.constants.MessageStatusConstants
   */
  messageStatus: MessageStatus

  /**
   * 消息标题
   */
  messageTitle: string

  /**
   * 消息内容
   */
  messageContent: string

  /**
   * 消息处理人
   */
  messageHandler: number

  /**
   * 创建时间
   */
  createTime?: Date

  /**
   * 创建人
   */
  createBy?: string

  /**
   * 最后修改时间
   */
  updateTime?: Date

  /**
   * 更新人
   */
  updateBy?: string
}

export type MessageRecordType = MerchantMessageRecord

export type MessagePageListData = IApiPageResponseData<MessageRecordType>
